const firebase = require("firebase");
// Required for side-effects
require("firebase/firestore");
require("firebase/auth");

const firebaseConfig = {
  apiKey: "AIzaSyD4l-E-Vq2hqrF8I2jZoo2tXdRoGhxcZoc",
  authDomain: "project-a-33732.firebaseapp.com",
  databaseURL: "https://project-a-33732.firebaseio.com",
  projectId: "project-a-33732",
  storageBucket: "project-a-33732.appspot.com",
  messagingSenderId: "868979818871",
  appId: "1:868979818871:web:8546f2f6bb966826e96172",
};

firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();
const auth = firebase.auth();

export { db, auth };
